module.exports = __webpack_public_path__ + "img/9.96f23b64.png";